<template>
  <div class="context-menu" @click.stop>
    <button
      class="context-menu__button"
      ref="addButton"
      :class="{ rotate: icon === 'icon-more' }"
    >
      <icon :name="icon" />
    </button>
    <ul class="context-menu__list" ref="contextMenu">
      <li
        v-for="item in items"
        :key="item.id"
        class="context-menu__item"
        :class="{ delete: item.title.includes('מחק') }"
        @click.stop="selectedContext(item)"
      >
        {{ item.title }}
        <svg
          v-if="item.iconSvg"
          class="icon-delete"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <path
            :d="item.iconSvg"
            stroke="#5A6F95"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        <icon v-else-if="item.icon" :name="item.icon" class="icon-delete" />
      </li>
    </ul>
  </div>
</template>

<script>
import { tippy } from 'vue-tippy';
export default {
  props: {
    items: Array,
    icon: {
      type: String,
      default: 'icon-more'
    }
  },
  data() {
    return {
      isOpen: false
    };
  },
  mounted() {
    this.tippyInstance = tippy(this.$refs.addButton, {
      content: this.$refs.contextMenu,
      placement: 'bottom-start',
      trigger: 'click',
      interactive: true,
      hideOnClick: true
    });
  },
  methods: {
    selectedContext(item) {
      this.$emit('selectedContext', item);
      this.tippyInstance.hide();
    },
    toggleMenu() {
      this.isOpen = !this.isOpen;
    }
  }
};
</script>

<style lang="scss" scoped>
.icon-delete {
  stroke: black;
  flex-shrink: 0;
  transition: 0.3s;
}
.icon-delete:hover {
  stroke: red;
  transition: 0.3s;
}
.tippy-backdrop {
  background-color: #ffffff !important;
}
.rotate {
  svg {
    transform: rotate(90deg);
  }
}
.context-menu {
  position: relative;
  &__button {
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    padding: 0;
    background-color: transparent;
    stroke: #38455d;
    // svg {
    //   transform: rotate(90deg);
    // }
  }
  &__list {
    width: 240px;
    border-radius: 8px;
    border: 1px solid var(--dark-grey-tints-light-grey, #e3e7ee);
    background: var(--background-white, #fff);
    box-shadow: 0px 2px 4px 0px rgba(56, 69, 93, 0.04),
      0px 4px 12px -2px rgba(56, 69, 93, 0.12);
    padding: 4px 0;
    li {
      padding: 6px 12px;
      font-weight: 400;
      font-size: 14px;
      line-height: 24px;
      color: #000000;

      cursor: pointer;
      text-align: right;
      transition: 0.3s;
      display: flex;
      justify-content: flex-end;
      gap: 8px;
      flex-direction: row-reverse;
      white-space: nowrap;
      &:not(:last-child) {
        margin-bottom: 8px;
      }
      &:hover {
        background: #eef7ff;
      }
    }
    .delete {
      color: red;
    }
  }
}
</style>
